import { render, staticRenderFns } from "./DashboardBoard.vue?vue&type=template&id=4eda4c39&scoped=true"
import script from "./DashboardBoard.vue?vue&type=script&lang=js"
export * from "./DashboardBoard.vue?vue&type=script&lang=js"
import style0 from "./DashboardBoard.vue?vue&type=style&index=0&id=4eda4c39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eda4c39",
  null
  
)

export default component.exports